import * as React from 'react';
import { useRoutes } from 'react-router-dom';
import routes from '@/router';
import UiLoader from '@/ui/UiLoader/UiLoader';
import Header from './Header';
import Footer from './Footer';
import useElementsNavigation from '@/hooks/useElementsNavigation';

export default function Layout() {
  const router = useRoutes(routes);
  useElementsNavigation();

  return (
    <div className="layout">
      <title>AuthSDK Example: Public</title>
      <Header />
      <div className="main">
        <React.Suspense fallback={<UiLoader />}>
          {router}
        </React.Suspense>
      </div>
      <Footer />
    </div>
  );
}
